export function constructSquadMemberList({ costume, live, cheer, crockett }) {
  const membersList = [
    costume ? "Smokey (costume)" : null,
    live ? "Smokey X (live)" : null,
    cheer ? "Cheer/Dance Team" : null,
    crockett ? "Davy Crockett" : null
  ];

  let memberText = "";

  membersList.forEach(member => {
    if (member) {
      memberText += memberText.length !== 0 ? `, ${member}` : member;
    }
  });

  return memberText;
}



// WEBPACK FOOTER //
// ./src/Spirit/util.js